<template>
  <div>
    <div class="title">{{ $t('date-title') }}</div>
    <div class="date-box">
      <a-button class="card-button" :class="choosePerfId === item.id ? 'active' : ''" v-for="item in dateList"
        :key="item.id" @click="clickDate(item)">
        <div class="date-box-left">
          <div class="monthYear">
            {{
              `${getMonth(getDate(item))}，${getDate(item).getFullYear()}`
            }}
          </div>
          <div class="day">{{ getDate(item).getDate() }}</div>
        </div>
        <div class="date-box-right">
          <div class="weekTime">
            {{
              `${getWeek(getDate(item))}
            ，
            ${padStart(getDate(item).getHours(), 2, 0)}
            :
            ${padStart(getDate(item).getMinutes(), 2, 0)}`
            }}
          </div>
          <div class="name" v-if="name">{{ name }}</div>
        </div>
      </a-button>
    </div>
  </div>
</template>

<script>
import { padStart } from '@/utils/utils'
import moment from 'moment'
export default {
  props: {
    dateList: {
      type: Array,
      default: () => []
    },
    defaultDateId: {
      type: Number,
      default: null
    },
    name: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      i18nMonthField: ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'],
      i18nWeekField: ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'],
      choosePerfId: this.defaultDateId
    }
  },
  computed: {
    getDate () {
      return (dateItem) => {
        return moment(dateItem.starts_timestamp * 1000).toDate()
      }
    },
    getMonth () {
      return (date) => {
        return this.$t(`month-title-${this.i18nMonthField[date.getMonth()]}`)
      }
    },
    getWeek () {
      return (date) => {
        return this.$t(`week-title-${this.i18nWeekField[date.getDay()]}`)
      }
    }
  },
  watch: {
    defaultDateId (newVal) {
      this.choosePerfId = newVal
    }
  },
  methods: {
    clickDate (item) {
      this.choosePerfId = item.id
      this.$emit('clickDate', item)
    },
    padStart
  }
}
</script>

<style lang="scss" scoped>
.title {
  @include font_color('detail-buy_title');
  font-size: 1.3125rem;
  font-weight: 700;
  @media (max-width: 991px) {
    font-size: 0.875rem;
  }
}

.card-button {
  width: 100%;
  height: auto;
  margin: 0.625rem 0;
  padding: 6px;
  display: flex;
  border: 0.125rem solid #465aba;
  @include border_color('detail-buy_border');
  font-size: 1.3125rem;
  background-color: transparent;

  &:first-of-type {
    margin-top: 0;
  }

  &:last-of-type {
    margin-bottom: 0;
  }

  &:hover {
    border-color: #007bff;
    @include border_color('detail-buy_border-hover');
  }

  &:focus {
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
  }
  &:hover,
  &.active {
    @include background_color('detail-buy_background-active');
    .date-box-left .day,
    .date-box-right .name {
      color: #272d4e;
      color: #272d4e;
    }
  }

  &:disabled {
    opacity: 0.65;
  }

  @media (max-width: 991px) {
    padding: .5rem .375rem;
  }
}

.date-box {
  margin: 10px -5px;
  padding: 0 5px;
  max-height: 20.625rem;
  overflow-y: scroll;
  /* 自定义滚动条 */
  &::-webkit-scrollbar-track-piece {
    background-color: rgba(0, 0, 0, 0);
    border-left: 1px solid rgba(0, 0, 0, 0);
  }
  &::-webkit-scrollbar {
    width: 3px;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb {
    @include background("scroll_default_bgc");
    background-clip: padding-box;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    min-height: 28px;
  }
  &::-webkit-scrollbar-thumb:hover {
    @include background("scroll_default_bgc");
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
  }
  & + .date-box {
    margin-top: 30px;
  }
}

.date-box-left {
  text-align: center;
  margin-right: 0.5rem;
  padding: 0 5px;
  line-height: 2rem;

  .monthYear {
    color: #eb5757;
    font-size: 1rem;
  }

  .day {
    font-size: 1.875rem;
    @include font_color('detail-buy_day');
  }
    @media (max-width: 991px) {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-left: .75rem;
      margin-right: .375rem;
      padding: 0;
    }
}

.date-box-right {
  width: 100%;
  text-align: left;
  position: relative;
  white-space: pre-wrap;

  .weekTime {
    @include font_color('detail-buy_title');

    @media (min-width: 80rem) {
      font-size: 1.3125rem;
    }
    @media (max-width: 991px) {
      font-size: 1.125rem;
    }

    font-size: 1.1875rem;
    display: inline-block;
  }

  .name {
    margin-top: 5px;
    white-space: initial;

    @media (min-width: 100rem) {
      font-size: 1.125rem;
    }

    @media (min-width: 80rem) {
      font-size: 1rem;
    }
    font-size: 0.875rem;
    @include font_color('detail-title');
  }
}

.limited {
  position: absolute;
  top: 0.3rem;
  right: 0.5rem;
  background: #f2c94c;
  padding: 0 0.3125rem;
  border-radius: 1rem;
  font-size: 0.75rem;
  color: #000;
  display: flex;
  align-items: center;

  img {
    display: block;
    margin-right: 2px;
    max-width: 0.875rem;
  }
}
</style>
